import { defineMessages } from 'react-intl';

export default defineMessages({
    allTeachers: {
        id: 'app.components.classFilter.allTeachers',
        defaultMessage: 'All teachers'
    },
    allYears: {
        id: 'app.components.classFilter.allYears',
        defaultMessage: 'All years'
    },
    clear: {
        id: 'app.components.classFilter.clear',
        defaultMessage: 'clear'
    }
});



// WEBPACK FOOTER //
// ./app/components/class-filter/messages.js